module.exports = __webpack_public_path__ + "img/part4.a6cf4e0f.png";